<template>
  <v-card>
    <v-card-title> Price Lists </v-card-title>
    <v-card-text>
      <v-btn color="success" class="mr-2" @click.stop="downloadPriceList()">
        Download Giclee Price List
        <v-icon class="ml-4"> mdi-download </v-icon>
      </v-btn>
      <v-btn color="success" disabled="true" class="mr-2" @click.stop="downloadExcel()">
        Download Excel Price List
        <v-icon class="ml-4"> mdi-download </v-icon>
      </v-btn>
      <v-card-text v-if="loading" class="mt-4 text-center">
        <h2 class="mt-4 mb-4 text-center">Please wait while we generate the document</h2>
        <v-progress-circular
          indeterminate
          :size="70"
          :width="7"
          color="green"
        ></v-progress-circular>
      </v-card-text>
    </v-card-text>
  </v-card>
</template>

<script>
import ProductApi from "@/api/admin/product";

export default {
  data() {
    return {};
  },
  async created() {},
  computed: {},
  methods: {
    async downloadExcel() {
      this.loading = true;
      ProductApi.getPriceList().then((results) => {
        console.log(results);
        this.loading = false;
      });
    },
    async downloadPriceList() {
      this.loading = true;
      ProductApi.getPriceListPDF().then((results) => {
        this.loading = false;
      });
    },
  },
};
</script>
